export default __webpack_public_path__ + "static/media/logo-segunda-seguros.ace2383d.png";